import { graphql, commitMutation } from 'react-relay';

const mutation = graphql`
    mutation FindingSharedModifyPortfolioItemsMutation($input: ModifyPortfolioItemsInput!) {
        modifyPortfolioItems(input: $input) {
            removedItemIds
        }
    }
`;

function commit(environment, args) {
    const { action, id, itemId, userId, onCompleted, onError, portfolioType } = args;
    const input = { action, userId, portfolioType };

    input.itemsIds = [itemId];

    const variables = {
        input,
        userId,
        itemId,
    };
    const isFavorite = action === 'REMOVE' ? false : true;
    const updater = id
        ? store => store.get(id).setValue(isFavorite, 'isFavorite', { userId })
        : () => ({});

    commitMutation(environment, {
        mutation,
        variables,
        optimisticUpdater: updater,
        updater,
        onCompleted,
        onError,
    });
}

export const SharedModifyPortfolioItems = {
    commit,
};
